// extracted by mini-css-extract-plugin
export default {"dropbtn":"PositionMenu_dropbtn__bWf5Z","dropdown":"PositionMenu_dropdown__0zCGH","dropdownContent":"PositionMenu_dropdownContent__GQ+nf"};